var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contact-module-rules" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("div", { staticClass: "header-left" }, [
          _c("h2", [_vm._v(_vm._s(_vm.$t("contactModuleRules.title")))]),
          _vm._v(" "),
          _c("p", { staticClass: "description" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("contactModuleRules.description")) +
                "\n            "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "header-right" },
          [
            _c("a-switch", {
              attrs: { size: "large" },
              on: { change: _vm.onMasterToggle },
              model: {
                value: _vm.enabled,
                callback: function ($$v) {
                  _vm.enabled = $$v
                },
                expression: "enabled",
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "toggle-label" }, [
              _vm._v(
                _vm._s(
                  _vm.enabled
                    ? _vm.$t("contactModuleRules.active")
                    : _vm.$t("contactModuleRules.passive")
                )
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "loading-container" },
            [_c("a-spin", { attrs: { size: "large" } })],
            1
          )
        : _vm.enabled
        ? _c(
            "div",
            { staticClass: "rules-container" },
            [
              _c(
                "draggable",
                {
                  staticClass: "rules-list",
                  attrs: { handle: ".drag-handle" },
                  on: { end: _vm.onRulesReordered },
                  model: {
                    value: _vm.rules,
                    callback: function ($$v) {
                      _vm.rules = $$v
                    },
                    expression: "rules",
                  },
                },
                _vm._l(_vm.rules, function (rule) {
                  return _c(
                    "div",
                    {
                      key: rule.id,
                      staticClass: "rule-card",
                      class: { disabled: !rule.enabled },
                    },
                    [
                      _c("div", { staticClass: "rule-header" }, [
                        _c("div", { staticClass: "rule-header-left" }, [
                          _c(
                            "i",
                            { staticClass: "material-icons drag-handle" },
                            [_vm._v("drag_indicator")]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "rule-name" }, [
                            _vm._v(_vm._s(rule.name)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "rule-header-right" },
                          [
                            _c("a-switch", {
                              attrs: { size: "small" },
                              on: {
                                change: function ($event) {
                                  return _vm.onRuleToggle(rule.id, $event)
                                },
                              },
                              model: {
                                value: rule.enabled,
                                callback: function ($$v) {
                                  _vm.$set(rule, "enabled", $$v)
                                },
                                expression: "rule.enabled",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "a-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editRule(rule)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("edit"),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-button",
                              {
                                attrs: {
                                  type: "text",
                                  size: "small",
                                  danger: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.confirmDeleteRule(rule)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("delete"),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "rule-body" }, [
                        _c("div", { staticClass: "rule-summary" }, [
                          _c(
                            "div",
                            { staticClass: "summary-line when-summary" },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("schedule"),
                              ]),
                              _vm._v(" "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.$t("contactModuleRules.when"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.getWhenLabel(rule.when))),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "summary-line conditions-summary" },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("filter_list"),
                              ]),
                              _vm._v(" "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("contactModuleRules.conditions")
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.getConditionsSummary(rule.conditions)
                                  ),
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "summary-line actions-summary" },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("bolt"),
                              ]),
                              _vm._v(" "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.$t("contactModuleRules.actions"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.getActionsSummary(rule.actions)
                                  ),
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "else-card" }, [
                _c(
                  "div",
                  { staticClass: "else-header" },
                  [
                    _c("div", { staticClass: "else-title" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("block"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("contactModuleRules.elseTitle"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: { click: _vm.editElseActions },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("edit"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "else-body" }, [
                  _vm.elseActions.length === 0
                    ? _c("div", { staticClass: "no-actions" }, [
                        _vm._v(
                          _vm._s(_vm.$t("contactModuleRules.noActionsDefined"))
                        ),
                      ])
                    : _c("div", { staticClass: "else-summary" }, [
                        _c(
                          "div",
                          { staticClass: "summary-line actions-summary" },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("bolt"),
                            ]),
                            _vm._v(" "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.$t("contactModuleRules.actions"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getActionsSummary(_vm.elseActions)
                                ),
                              },
                            }),
                          ]
                        ),
                      ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "add-rule-btn",
                  on: { click: _vm.createNewRule },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("add_circle"),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("contactModuleRules.addNewRule"))),
                  ]),
                ]
              ),
            ],
            1
          )
        : _c("div", { staticClass: "empty-state" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("h3", [
              _vm._v(_vm._s(_vm.$t("contactModuleRules.rulesDisabled"))),
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.$t("contactModuleRules.enableHint")))]),
          ]),
      _vm._v(" "),
      _vm.showRuleEditor
        ? _c("RuleEditor", {
            attrs: { rule: _vm.editingRule, visible: _vm.showRuleEditor },
            on: { close: _vm.closeRuleEditor, save: _vm.saveRule },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showElseActionsEditor
        ? _c("ElseActionsEditor", {
            attrs: {
              actions: _vm.elseActions,
              visible: _vm.showElseActionsEditor,
            },
            on: {
              close: _vm.closeElseActionsEditor,
              save: _vm.saveElseActions,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showRuleTester
        ? _c("RuleTester", {
            attrs: { visible: _vm.showRuleTester },
            on: {
              close: function ($event) {
                _vm.showRuleTester = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("account_tree")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }